import React from 'react'
import ReactDOM from 'react-dom'
import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from 'react-redux'
import { store, persistor } from './store'
import App from './App'
import { BrowserRouter } from 'react-router-dom'
import { ConfigProvider } from 'antd'
import ruRU from 'antd/es/locale/ru_RU'
import { ThemeProvider } from '@material-ui/core'
import materialTheme from './materialTheme'
import { AuthConfigProvider } from './components/AuthConfigProvider'

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <ConfigProvider locale={ruRU}>
          <ThemeProvider theme={materialTheme}>
            <AuthConfigProvider>
              <App />
            </AuthConfigProvider>
          </ThemeProvider>
        </ConfigProvider>
      </BrowserRouter>
    </PersistGate>
  </Provider>,
  document.getElementById('root')
)
